/**
 * Client-side utilities
 */

// String utilities
export { escapeHtml, truncate, truncateStart } from './string';

// Formatting utilities
export {
  formatScore,
  formatDistance,
  formatTimeAgo,
  formatHeightImperial,
  formatHeight,
  formatWeight,
  calculateAge,
} from './format';
export type { Units } from './format';

// Units helper
export { getUnits, sliderToKm, kmToSlider, sliderToDisplayLabel, DISTANCE_SLIDER } from './units';

// Date utilities
export { formatMessageDate, formatMessageTime, formatFriendlyDate } from './date';

// HTML template generators
export { loadingSpinner, emptyState, errorState, saveIndicator } from './html';

// Form utilities
export { showSaveIndicator, debounce, clearDebounce, flushDebounce, setupDeselectableRadios, wantsKidsLabel } from './form';

// Gesture utilities
export { setupSwipeDetection, setupDoubleTapDetection } from './gestures';
export type { SwipeOptions, DoubleTapOptions } from './gestures';

// Page-flip gesture
export { setupPageFlipGesture, triggerPageFlip } from './page-flip';
